import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANY_BANNERS = "fetchCompanyBanners";
export const FETCH_COMPANY_BANNER = "fetchCompanyBanner";
export const STORE_COMPANY_BANNER = "storeCompanyBanner";
export const UPDATE_COMPANY_BANNER = "updateCompanyBanner";
export const DESTROY_COMPANY_BANNER = "destroyCompanyBanner";

// mutation types
export const SET_COMPANY_BANNERS = "setCompanyBanners";
export const SET_COMPANY_BANNERS_PAGINATION = "setCompanyBannersPagination";
export const SET_COMPANY_BANNER = "setCompanyBanner";

const state = {
  companyBanners: [],
  companyBannersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  companyBanner: {}
};

const getters = {
  companyBanners(state) {
    return state.companyBanners;
  },
  companyBannersPagination(state) {
    return state.companyBannersPagination;
  },
  companyBanner(state) {
    return state.companyBanner;
  }
};

const actions = {
  [FETCH_COMPANY_BANNERS](context) {
    let params = {
      page: context.state.companyBannersPagination.currentPage
    };

    return new Promise((resolve, reject) => {
      ApiService.query("company/banners", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_BANNERS, data.data);
          context.commit(SET_COMPANY_BANNERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_COMPANY_BANNER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query("profile", {
        params: {
          banner: id
        }
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_BANNER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_COMPANY_BANNER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("company/banners", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_COMPANY_BANNER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("profile", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_COMPANY_BANNER](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`company/banners/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_COMPANY_BANNERS](state, companyBanners) {
    state.companyBanners = companyBanners;
  },
  [SET_COMPANY_BANNERS_PAGINATION](state, data) {
    state.companyBannersPagination = data;
  },
  [SET_COMPANY_BANNER](state, companyBanner) {
    state.companyBanner = companyBanner;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
